const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "192px",
    height: "192px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#fe8801",
    d: "M 10.5,-0.5 C 67.1667,-0.5 123.833,-0.5 180.5,-0.5C 184.5,2.83333 188.167,6.5 191.5,10.5C 191.5,67.1667 191.5,123.833 191.5,180.5C 188.167,184.5 184.5,188.167 180.5,191.5C 123.833,191.5 67.1667,191.5 10.5,191.5C 6.5,188.167 2.83333,184.5 -0.5,180.5C -0.5,123.833 -0.5,67.1667 -0.5,10.5C 2.83333,6.5 6.5,2.83333 10.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4750b",
    d: "M 157.5,47.5 C 157.167,47.5 156.833,47.5 156.5,47.5C 156.477,45.0733 155.977,42.74 155,40.5C 152.578,38.2504 150.411,35.9171 148.5,33.5C 146.833,33.5 145.167,33.5 143.5,33.5C 144.128,25.5296 148.128,23.3629 155.5,27C 158.427,29.3824 161.261,31.8824 164,34.5C 167.387,41.9065 165.221,46.2399 157.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#daa00f",
    d: "M 148.5,33.5 C 147.699,31.9582 147.366,30.2915 147.5,28.5C 152.494,27.8129 155.494,29.8129 156.5,34.5C 153.833,34.1667 151.167,33.8333 148.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6f3d28",
    d: "M 143.5,33.5 C 145.167,33.5 146.833,33.5 148.5,33.5C 150.411,35.9171 152.578,38.2504 155,40.5C 155.977,42.74 156.477,45.0733 156.5,47.5C 153.129,50.8706 150.129,54.5373 147.5,58.5C 145.413,59.5846 144.08,61.2512 143.5,63.5C 139.124,66.8744 135.458,70.8744 132.5,75.5C 131.504,75.5858 130.671,75.2524 130,74.5C 129.667,71.8333 129.333,69.1667 129,66.5C 125.225,62.1462 120.725,59.4795 115.5,58.5C 116.167,58.5 116.5,58.1667 116.5,57.5C 120.704,55.9668 124.037,53.3002 126.5,49.5C 132.167,44.1667 137.833,38.8333 143.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#975538",
    d: "M 143.5,38.5 C 149.709,37.7485 152.709,40.4152 152.5,46.5C 148.266,45.2686 145.266,42.6019 143.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9e593a",
    d: "M 137.5,43.5 C 144.334,43.656 147.001,46.9894 145.5,53.5C 142.358,50.3785 139.691,47.0452 137.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a17410",
    d: "M 93.5,41.5 C 100.462,47.2914 107.295,53.2914 114,59.5C 114.383,58.944 114.883,58.6107 115.5,58.5C 120.725,59.4795 125.225,62.1462 129,66.5C 129.333,69.1667 129.667,71.8333 130,74.5C 130.671,75.2524 131.504,75.5858 132.5,75.5C 132.5,75.8333 132.5,76.1667 132.5,76.5C 137.387,83.5651 142.887,90.2317 149,96.5C 150.254,100.111 149.088,101.611 145.5,101C 139.5,96 133.5,91 127.5,86C 126.552,85.5172 125.552,85.3505 124.5,85.5C 124.586,84.5041 124.252,83.6708 123.5,83C 119.612,82.154 115.945,80.9874 112.5,79.5C 111.833,78.5 111.167,77.5 110.5,76.5C 111.978,76.762 113.311,76.4287 114.5,75.5C 113.246,73.3569 113.246,71.3569 114.5,69.5C 114.253,71.8583 114.919,73.8583 116.5,75.5C 123.253,78.2476 125.586,76.2476 123.5,69.5C 123.167,68.5 122.5,67.8333 121.5,67.5C 119.611,66.2584 117.611,66.2584 115.5,67.5C 107.369,58.8683 99.0357,50.3683 90.5,42C 91.448,41.5172 92.448,41.3505 93.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9d593a",
    d: "M 131.5,48.5 C 135.446,48.5966 138.612,50.2633 141,53.5C 141.808,55.5787 141.641,57.5787 140.5,59.5C 137.48,56.6454 134.313,53.9787 131,51.5C 130.53,50.4232 130.697,49.4232 131.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#914e1d",
    d: "M 126.5,49.5 C 124.037,53.3002 120.704,55.9668 116.5,57.5C 119.539,54.4602 122.873,51.7935 126.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c46911",
    d: "M 156.5,47.5 C 156.833,47.5 157.167,47.5 157.5,47.5C 154.877,51.7908 151.544,55.4575 147.5,58.5C 150.129,54.5373 153.129,50.8706 156.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dda114",
    d: "M 93.5,41.5 C 92.448,41.3505 91.448,41.5172 90.5,42C 99.0357,50.3683 107.369,58.8683 115.5,67.5C 115.5,67.8333 115.5,68.1667 115.5,68.5C 114.833,68.5 114.5,68.8333 114.5,69.5C 113.246,71.3569 113.246,73.3569 114.5,75.5C 113.311,76.4287 111.978,76.762 110.5,76.5C 110.5,75.8333 110.167,75.5 109.5,75.5C 110.691,70.5308 109.024,67.1975 104.5,65.5C 105.501,64.2113 105.334,62.8779 104,61.5C 99.3333,56.1667 94.6667,50.8333 90,45.5C 89.5065,43.8659 89.3398,42.1992 89.5,40.5C 91.099,40.2322 92.4324,40.5655 93.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9c593a",
    d: "M 125.5,53.5 C 133.212,54.5372 136.879,58.8705 136.5,66.5C 133.95,66.4392 132.45,65.1059 132,62.5C 127.735,60.4894 125.568,57.4894 125.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#506276",
    d: "M 121.5,67.5 C 119.435,67.5172 117.435,67.8505 115.5,68.5C 115.5,68.1667 115.5,67.8333 115.5,67.5C 117.611,66.2584 119.611,66.2584 121.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8e0e1",
    d: "M 109.5,75.5 C 110.167,75.5 110.5,75.8333 110.5,76.5C 111.167,77.5 111.833,78.5 112.5,79.5C 83.7507,106.748 55.4174,134.581 27.5,163C 28.448,163.483 29.448,163.649 30.5,163.5C 29.2196,164.931 27.5529,165.598 25.5,165.5C 26.1269,158.636 28.1269,152.303 31.5,146.5C 32.9063,146.027 33.573,145.027 33.5,143.5C 35.914,142.089 37.5806,140.089 38.5,137.5C 39.9063,137.027 40.573,136.027 40.5,134.5C 43.8333,133.167 46.1667,130.833 47.5,127.5C 48.1667,126.167 49.1667,125.167 50.5,124.5C 52.1667,123.5 53.5,122.167 54.5,120.5C 57.2427,118.761 59.2427,116.427 60.5,113.5C 62.1667,111.167 64.1667,109.167 66.5,107.5C 69.2427,105.761 71.2427,103.427 72.5,100.5C 74.1667,98.1667 76.1667,96.1667 78.5,94.5C 79.8333,93.8333 80.8333,92.8333 81.5,91.5C 84.2427,89.7607 86.2427,87.4274 87.5,84.5C 89.1667,82.1667 91.1667,80.1667 93.5,78.5C 95.5869,77.4154 96.9202,75.7488 97.5,73.5C 100.412,71.9337 103.079,69.9337 105.5,67.5C 107.13,70.0202 108.463,72.6868 109.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2d0ae",
    d: "M 104.5,65.5 C 109.024,67.1975 110.691,70.5308 109.5,75.5C 108.463,72.6868 107.13,70.0202 105.5,67.5C 103.079,69.9337 100.412,71.9337 97.5,73.5C 99.8333,70.8333 102.167,68.1667 104.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c5684",
    d: "M 121.5,67.5 C 122.5,67.8333 123.167,68.5 123.5,69.5C 123.784,71.4147 123.451,73.0813 122.5,74.5C 122.552,72.0971 122.219,69.7638 121.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf6612",
    d: "M 143.5,63.5 C 140.202,68.1323 136.536,72.4656 132.5,76.5C 132.5,76.1667 132.5,75.8333 132.5,75.5C 135.458,70.8744 139.124,66.8744 143.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3766ad",
    d: "M 121.5,67.5 C 122.219,69.7638 122.552,72.0971 122.5,74.5C 120.735,75.4614 118.735,75.7947 116.5,75.5C 114.919,73.8583 114.253,71.8583 114.5,69.5C 114.5,68.8333 114.833,68.5 115.5,68.5C 117.435,67.8505 119.435,67.5172 121.5,67.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7c6938",
    d: "M 123.5,69.5 C 125.586,76.2476 123.253,78.2476 116.5,75.5C 118.735,75.7947 120.735,75.4614 122.5,74.5C 123.451,73.0813 123.784,71.4147 123.5,69.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dec193",
    d: "M 97.5,73.5 C 96.9202,75.7488 95.5869,77.4154 93.5,78.5C 94.0798,76.2512 95.4131,74.5846 97.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#86aebd",
    d: "M 112.5,79.5 C 115.945,80.9874 119.612,82.154 123.5,83C 124.252,83.6708 124.586,84.5041 124.5,85.5C 124.167,86.1667 123.833,86.8333 123.5,87.5C 120.911,88.4194 118.911,90.086 117.5,92.5C 115.167,94.1667 113.167,96.1667 111.5,98.5C 109.5,98.5 108.5,99.5 108.5,101.5C 107.833,101.5 107.5,101.833 107.5,102.5C 104.911,103.419 102.911,105.086 101.5,107.5C 98.8333,109.5 96.5,111.833 94.5,114.5C 91.9108,115.419 89.9108,117.086 88.5,119.5C 84.8333,122.5 81.5,125.833 78.5,129.5C 75.9108,130.419 73.9108,132.086 72.5,134.5C 69.141,137.529 65.8076,140.529 62.5,143.5C 59.1667,146.167 56.1667,149.167 53.5,152.5C 50.4771,154.533 47.4771,156.533 44.5,158.5C 41.4553,159.279 38.7886,160.613 36.5,162.5C 34.5,162.833 32.5,163.167 30.5,163.5C 29.448,163.649 28.448,163.483 27.5,163C 55.4174,134.581 83.7507,106.748 112.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dac7a0",
    d: "M 87.5,84.5 C 86.2427,87.4274 84.2427,89.7607 81.5,91.5C 82.7573,88.5726 84.7573,86.2393 87.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe5c9",
    d: "M 63.5,87.5 C 65.1486,88.714 66.8152,90.0473 68.5,91.5C 66.8333,92.5 65.5,93.8333 64.5,95.5C 63.1239,94.1581 61.7906,92.8248 60.5,91.5C 62.2882,90.7174 63.2882,89.3841 63.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#da933e",
    d: "M 123.5,87.5 C 122.089,89.914 120.089,91.5806 117.5,92.5C 118.911,90.086 120.911,88.4194 123.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dec08f",
    d: "M 81.5,91.5 C 80.8333,92.8333 79.8333,93.8333 78.5,94.5C 78.5,92.5 79.5,91.5 81.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d19648",
    d: "M 111.5,98.5 C 110.833,99.8333 109.833,100.833 108.5,101.5C 108.5,99.5 109.5,98.5 111.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffc585",
    d: "M 40.5,96.5 C 42.2132,97.6354 42.8799,99.302 42.5,101.5C 43.8333,101.5 45.1667,101.5 46.5,101.5C 46.5,102.5 46.5,103.5 46.5,104.5C 45.1667,104.5 43.8333,104.5 42.5,104.5C 42.762,105.978 42.4287,107.311 41.5,108.5C 39.5038,106.391 37.1705,104.724 34.5,103.5C 35.6554,102.05 37.1554,101.05 39,100.5C 39.4101,99.0993 39.9101,97.766 40.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#db923b",
    d: "M 107.5,102.5 C 106.089,104.914 104.089,106.581 101.5,107.5C 102.911,105.086 104.911,103.419 107.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcc498",
    d: "M 72.5,100.5 C 71.2427,103.427 69.2427,105.761 66.5,107.5C 67.7573,104.573 69.7573,102.239 72.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffc585",
    d: "M 117.5,103.5 C 119.912,103.694 120.912,105.027 120.5,107.5C 122.346,107.222 123.68,107.889 124.5,109.5C 123.311,110.429 121.978,110.762 120.5,110.5C 119.572,117.092 118.572,117.092 117.5,110.5C 115.654,110.778 114.32,110.111 113.5,108.5C 114.32,106.889 115.654,106.222 117.5,106.5C 117.5,105.5 117.5,104.5 117.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffdcb6",
    d: "M 55.5,107.5 C 56.5,107.5 57.5,107.5 58.5,107.5C 58.5,108.5 58.5,109.5 58.5,110.5C 55.5065,110.854 54.5065,109.854 55.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d69441",
    d: "M 94.5,114.5 C 93.0892,116.914 91.0892,118.581 88.5,119.5C 89.9108,117.086 91.9108,115.419 94.5,114.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbc7a0",
    d: "M 60.5,113.5 C 59.2427,116.427 57.2427,118.761 54.5,120.5C 55.7573,117.573 57.7573,115.239 60.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0be89",
    d: "M 54.5,120.5 C 53.5,122.167 52.1667,123.5 50.5,124.5C 50.8333,122.167 52.1667,120.833 54.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd7ab",
    d: "M 39.5,122.5 C 42.7094,123.297 43.2094,124.963 41,127.5C 39.7308,126.095 39.2308,124.429 39.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffd5a6",
    d: "M 109.5,133.5 C 107.907,132.652 106.74,131.319 106,129.5C 105.617,130.056 105.117,130.389 104.5,130.5C 104.843,128.775 105.843,128.275 107.5,129C 108.267,130.47 108.933,131.97 109.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fff1e1",
    d: "M 109.5,133.5 C 111.103,133.312 112.437,133.812 113.5,135C 110.314,136.092 107.647,137.925 105.5,140.5C 103.806,138.139 101.806,136.139 99.5,134.5C 101.363,133.311 103.03,131.978 104.5,130.5C 105.117,130.389 105.617,130.056 106,129.5C 106.74,131.319 107.907,132.652 109.5,133.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbc69f",
    d: "M 47.5,127.5 C 46.1667,130.833 43.8333,133.167 40.5,134.5C 42.5,131.833 44.8333,129.5 47.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#db923a",
    d: "M 78.5,129.5 C 77.0892,131.914 75.0892,133.581 72.5,134.5C 73.9108,132.086 75.9108,130.419 78.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0be89",
    d: "M 40.5,134.5 C 40.573,136.027 39.9063,137.027 38.5,137.5C 38.427,135.973 39.0937,134.973 40.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d9cba9",
    d: "M 38.5,137.5 C 37.5806,140.089 35.914,142.089 33.5,143.5C 34.4194,140.911 36.086,138.911 38.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffb563",
    d: "M 78.5,136.5 C 79.5,136.5 80.5,136.5 81.5,136.5C 81.4261,140.541 80.0928,141.208 77.5,138.5C 77.8627,137.817 78.1961,137.15 78.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3b97b",
    d: "M 33.5,143.5 C 33.573,145.027 32.9063,146.027 31.5,146.5C 31.427,144.973 32.0937,143.973 33.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e09133",
    d: "M 62.5,143.5 C 60.5,147.5 57.5,150.5 53.5,152.5C 56.1667,149.167 59.1667,146.167 62.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffe1bf",
    d: "M 69.5,149.5 C 75.3136,151.392 75.6469,153.725 70.5,156.5C 69.1667,155.833 68.1667,154.833 67.5,153.5C 68.6302,152.378 69.2969,151.044 69.5,149.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1964b",
    d: "M 44.5,158.5 C 42.4691,160.755 39.8025,162.088 36.5,162.5C 38.7886,160.613 41.4553,159.279 44.5,158.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.7576717085221481615eaa969ae6168e.svg";
export { ForwardRef as ReactComponent };